//import DashBoardLayerTwo from "../../components/dash/Dasboard";
import Dashboard from "../../components/dash/global/Dasboard";
import TutorialVideoPage from "../../components/test/Quiz/tutorial/TutorialVideoPage";
import MisTalentosPage from "../../pages/test/MisTalentosPage";
import QuizPage from "../../pages/test/Quiz/QuizPage";
import ConfirmacionTalentosPage from "../../pages/test/Quiz/ConfirmacionTalentosPage";
import TestPage from "../../pages/test/TestPage";
import { ROLES } from "../role.constants";

export const sharedRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/",
    element: <TestPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/test-quiz",
    element: <QuizPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/mis-talentos",
    element: <MisTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/confirmacion-talentos",
    element: <ConfirmacionTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
  {
    path: "/tutorial-video",
    element: <TutorialVideoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.ESTUDIANTE],
  },
];
